/*
 * nav-2026.js — Header/nav 2026 (ENG-7576)
 * Scoped to the section root (.section-header-2026 .header-2026): all queries run
 * inside `root`, so it never collides with global.js or the legacy header.
 * No-op if the section is not present on the page.
 */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.section-header-2026 .header-2026');
    if (!root) return;

    // ── Live cart count ──
    // The 2026 header prints the cart count as static Liquid, so it would go stale after an
    // add-to-cart. The legacy header's #cart-icon-bubble IS kept current by Shopify Section
    // Rendering (cart-drawer.js / cart.js / cart-notification.js / quick-add). It's the single
    // source of truth every cart path already updates, so we mirror its count into the 2026
    // nodes via a MutationObserver — no changes to the shared cart JS, and the legacy id stays
    // unique (we can't reuse #cart-icon-bubble: both headers still render together).
    (function () {
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;

      var deskCount = root.querySelector('.nav-utils .util-link .count');
      var mobileBadge = root.querySelector('.mobile-right .cart .cart-count');
      var overlayCount = root.querySelector('.mobile-account .cart-count-text');

      function readCount() {
        // Empty cart: .cart-count-bubble is absent → 0.
        var wrap = bubble.querySelector('.cart-count-bubble');
        if (!wrap) return 0;
        // Normal case: visible count lives in the aria-hidden span.
        var numEl = wrap.querySelector('[aria-hidden="true"]');
        if (numEl) {
          var n = parseInt(numEl.textContent.replace(/\D/g, ''), 10);
          return isNaN(n) ? 0 : n;
        }
        // count >= 100: legacy omits the numeric span; fall back to the "N items" a11y text.
        var vh = wrap.querySelector('.visually-hidden');
        var m = vh && vh.textContent.match(/\d+/);
        return m ? parseInt(m[0], 10) : 0;
      }

      function sync() {
        var count = readCount();
        if (deskCount) deskCount.textContent = '(' + count + ')';
        if (overlayCount) overlayCount.textContent = count;
        if (mobileBadge) {
          mobileBadge.textContent = count;
          mobileBadge.style.display = count > 0 ? '' : 'none';
        }
      }

      new MutationObserver(sync).observe(bubble, { childList: true, subtree: true });
    })();

    // ── Mega-menu / dropdown hover behavior (desktop) ──
    var wraps = root.querySelectorAll('.nav-link-wrap[data-menu]');
    var megaList = root.querySelectorAll('.mega[data-mega]');
    var megas = {};
    megaList.forEach(function (m) { megas[m.getAttribute('data-mega')] = m; });

    var openKey = null;
    var closeTimer = null;

    function closeAll() {
      Object.keys(megas).forEach(function (k) { megas[k].classList.remove('open'); });
      wraps.forEach(function (w) { w.classList.remove('open'); });
      var btns = root.querySelectorAll('.nav-link[aria-expanded]');
      btns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      openKey = null;
    }

    function openMenu(key, wrap) {
      if (openKey && openKey !== key) closeAll();
      var m = megas[key];
      if (!m) return;
      // Position single-column dropdowns under their trigger. The .nav-sticky wrapper
      // spans the full viewport width starting at left:0, so the trigger's viewport
      // left maps 1:1 to the absolute offset inside the wrapper.
      if (m.classList.contains('dropdown') && wrap) {
        var rect = wrap.getBoundingClientRect();
        m.style.left = rect.left + 'px';
      }
      m.classList.add('open');
      wrap.classList.add('open');
      var btn = wrap.querySelector('.nav-link[aria-expanded]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      openKey = key;
    }

    wraps.forEach(function (wrap) {
      var key = wrap.getAttribute('data-menu');
      wrap.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openMenu(key, wrap);
      });
      wrap.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(closeAll, 180);
      });
      var btn = wrap.querySelector('button.nav-link');
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (openKey === key) closeAll();
          else openMenu(key, wrap);
        });
      }
    });

    // Keep mega open while hovering the panel
    Object.keys(megas).forEach(function (key) {
      var m = megas[key];
      m.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      m.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(closeAll, 180);
      });
    });

    // ESC closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    // Click outside closes
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.nav-link-wrap') && !e.target.closest('.mega')) {
        closeAll();
      }
    });

    // ── Mobile overlay ──
    var hamburger = root.querySelector('.js-nav2026-hamburger');
    var mobileClose = root.querySelector('.js-nav2026-mobile-close');
    var overlay = root.querySelector('.mobile-overlay');

    if (hamburger && overlay) {
      hamburger.addEventListener('click', function () {
        overlay.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
    }
    if (mobileClose && overlay) {
      mobileClose.addEventListener('click', function () {
        overlay.classList.remove('open');
        document.body.style.overflow = '';
      });
    }

    if (overlay) {
      var mobileItems = overlay.querySelectorAll('.mobile-item');

      var scrollItemToTop = function (item) {
        item.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      mobileItems.forEach(function (item) {
        var trigger = item.querySelector('.mobile-trigger');
        if (!trigger || trigger.tagName === 'A') return; // direct-link items (no accordion)
        trigger.addEventListener('click', function () {
          var isOpen = item.classList.contains('open');
          var previouslyOpen = Array.prototype.find.call(mobileItems, function (i) {
            return i.classList.contains('open');
          });

          mobileItems.forEach(function (other) { other.classList.remove('open'); });

          if (isOpen) return;

          item.classList.add('open');

          if (previouslyOpen && previouslyOpen !== item) {
            var prevPanel = previouslyOpen.querySelector('.mobile-panel');
            var onEnd = function (e) {
              if (e.target !== prevPanel) return;
              prevPanel.removeEventListener('transitionend', onEnd);
              scrollItemToTop(item);
            };
            prevPanel.addEventListener('transitionend', onEnd);
            setTimeout(function () {
              prevPanel.removeEventListener('transitionend', onEnd);
              scrollItemToTop(item);
            }, 360);
          } else {
            requestAnimationFrame(function () { scrollItemToTop(item); });
          }
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
